<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <learningTenant-details ref="learningTenantDetails"
                       v-bind:learningTenant="learningTenant" />
    </v-card>
  </div>
</template>

<script>
  import LearningTenantDetails from '@/components/learning/LearningTenantDetails'

  export default {
    components: {
      LearningTenantDetails
    },
    name: 'LearningTenantDetailsCard',
    methods: {
      validate() {
        return this.$refs.learningTenantDetails.validate()
      }
    },
    props: {
      learningTenant: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>